import SiteIcon from "@/shared/components/SiteIcon";
import { siteName } from "@/shared/lib/sites";
import type { WebSource } from "@/shared/types";

/** A web source's site line: its favicon, the site without "www.", and its number. */
export default function SourceSite({ source }: { source: WebSource }) {
  return (
    <span className="flex items-center gap-1.5 min-w-0 text-[12px] text-[var(--text-tertiary)]">
      <SiteIcon url={source.url} site={source.site} size="line" />
      <span className="flex-1 min-w-0 truncate">{siteName(source.site)}</span>
      <span className="shrink-0 text-[11px] font-mono tabular-nums text-[var(--text-quaternary)]">{source.n}</span>
    </span>
  );
}
